import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { CssBaseline, Container } from "@mui/material";
import Login from "./components/auth/login";
import DashboardWrapper from "./components/dashboard/dashboardWrapper"; // Import DashboardWrapper
import BusinessCardDisplay from "./components/dashboard/businessCardDisplay";
import PrivateRoute from "./components/auth/privateRoute";
import NotFound from "./components/notfound";
import LandingPage from "./components/pages/LandingPage"; // Add this import

const App = () => {
  return (
    <Router>
      <CssBaseline />
      <Routes>
        <Route path="/" element={<LandingPage />} /> {/* Add this line */}
        {/* Public route for displaying the business card (QR code landing page) */}
        <Route
          path="/:companyName/business-card/:id"
          element={<BusinessCardDisplay />}
        />
        {/* Login page */}
        <Route
          path="/:companyName"
          element={
            <Container maxWidth="xs">
              <Login />
            </Container>
          }
        />
        <Route path="/404" element={<NotFound />} />
        {/* Protected dashboard route wrapped with DashboardWrapper */}
        <Route
          path="/:companyName/dashboard"
          element={
            <PrivateRoute>
              <DashboardWrapper />
            </PrivateRoute>
          }
        />
        {/* Fallback route for unmatched paths */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
};

export default App;
